module.exports = __webpack_public_path__ + "static/goku-9dc53b06d9b0abfd737ab668b99b2e9d.gif";